import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[autofocus]',
})
export class AutofocusDirective {
  focus = true;
  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.focus)
      setTimeout(() => {
        this.el.nativeElement.focus();
      });
  }
}
